// Landing.js
import React from "react";
import { useHistory } from "react-router-dom";
import Navbar from "../components/Navbar";
import "./Landing.css";
import { useTranslation } from "react-i18next";
import { FaRaspberryPi } from "react-icons/fa";
import DonationButton from "../components/DonationButton";
import DonationWheel from "../components/DonationWheel";
import MobileAppPromoFloat from "../components/MobileAppPromoFloat";
import "../containers/ModalTheme.css";
import "../containers/GroupPageCards.css";
import { useScene } from "../components/scene/SceneContext";
import SceneBackground from "../components/scene/SceneBackground";

export default function Landing() {
  const { t } = useTranslation();
  const history = useHistory();
  const { variant } = useScene();
  const logoSrc = `${process.env.PUBLIC_URL}/images/logo/logo.png`;

  const handleStart = () => {
    history.push(`${process.env.PUBLIC_URL}/group/new`);
  };

  const handleChat = () => {
    history.push(`${process.env.PUBLIC_URL}/chat`);
  };

  return (
    <div className={`d-flex flex-column inner-height landing landing--${variant}`}>
      <SceneBackground effectsProps={{ preset: "landing", showAnimals: true }} />
      <Navbar
        actionBtnIconClassName="bi-info-circle"
        showActionBtn
        handleActionBtnOnClick={() =>
          history.push(`${process.env.PUBLIC_URL}/terms`)
        }
        rightSlot={
          <>
            <DonationButton className="btn btn-sm as-btn-soft" />
            <button
              className="btn btn-sm as-btn-soft"
              onClick={() => history.push(`${process.env.PUBLIC_URL}/chat`)}
              title={t("general.ai_chat")}
            >
              <i className="bi bi-chat-dots" />
            </button>
            <button 
              className="btn btn-sm as-btn-soft" 
              onClick={() => history.push(`${process.env.PUBLIC_URL}/games`)}
              title="Games"
            >
              🎮
            </button>
          </>
        }
      />
       
 
      <div className="container-xl flex-grow-1 text-center d-flex flex-column justify-content-center landing-content">
        <div className="landing-hero-card as-theme">
          <div className="landing-hero-top">
            <div className="landing-hero-mascot" aria-hidden="true">
              <img className="landing-hero-logo" src={logoSrc} alt="" />
            </div>
            <h1 className="landing-title">
              <span className="typing-text">AnimalSplit</span>
              <span className="raspberry-container">
                <FaRaspberryPi className="raspberry-icon" />
                <span className="pi-text">Pi</span>
              </span>
            </h1>
          </div>

          <div className="landing-animal-strip" aria-hidden="true">
            🐶🐱🐰🦊🐻🐼🐨🐯🦁🐮🐷🐸🐵 🌿🌳
          </div>

          <p className="landing-slogan">{t("general.slogan")}</p>
          <div className="landing-actions">
            <button className="btn btn-lg as-btn-primary-gradient" onClick={handleStart}>
              {t("general.start")}
            </button>
            <button className="btn btn-lg as-btn-soft" onClick={handleChat} title={t("general.ai_chat")}>
              <i className="bi bi-chat-dots me-2" />
              {t("general.ai_chat")}
            </button>
          </div>
        </div>
      </div>
      <DonationWheel />
      <MobileAppPromoFloat />
    </div>
  );
}
